import { Currency } from '../../constants/currency.js';
import { getAmountString } from '../../helpers/humanization.js';

const getBukmekeryTerms = item => {
    const conditions = [];
    const { freeBet } = item;
    conditions.push({
        value: freeBet ? getAmountString(freeBet, Currency.RUB) : 'Индивидуально',
        description: 'Фрибет',
        key: 'freeBet',
    });
    conditions.push({ value: 'от 1 минуты', description: 'Вывод средств', key: 'vyvod' });
    return conditions;
};

export { getBukmekeryTerms };
//# sourceMappingURL=bukmekery.js.map
